
/**
 * Contracts
 */

export enum FixedValueUnitType {
    NAME = "name",
    DESCRIPTION = "description",
    MONETARY_AMOUNT = "monetary amount",
    TIME = "time",
    PERCENTAGE = "percentage",
    FILTERED_TERMS = "filteredTerms"
}

export enum UserAccountState {
    REGISTERED = "registered",
    ONBOARDED = "onboarded",
    PENDING = "pending",
}



